// @core/api/endpoints/activity/create_mapping_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateMappingConfigRequest,
  MappingConfigResponse,
} from '../../../types/activity';

const BASE_PATH = '/activity';

/**
 * Create activity mapping config
 * Creates a new mapping from a Kafka topic/event type to an Activity. Allows extending ActivityService to consume new event sources without code changes.
 */
export async function CreateMappingConfig(
  data: CreateMappingConfigRequest,
  options?: RequestOptions
): Promise<MappingConfigResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/activity-mappings`;
  const requestOptions = options;
  return client.post<MappingConfigResponse>(requestPath, data, requestOptions);
}
